module.exports = __webpack_public_path__ + "static/media/covid-lhr.555cc357.svg";